import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Activitykpi, Activity, ActivityCost } from 'toolbandi-ui-lib';
import { MessageService, ListService, ListItem, SharedDataService, CrudService, Search } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-project-costs-edit',
	templateUrl: './project-costs-edit.component.html',
	styleUrls: ['./project-costs-edit.component.scss']
})
export class ProjectCostsEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	cost: ActivityCost;
	title: string;
	companyid: number;
	projectid: number;


	types: ListItem[] = [];

	search: {
		activity: Search
	};
	selected: {
		activity: Activity
	};


	constructor(
		private messageService: MessageService,
		private translateService: TranslateService,
		private activeModal: NgbActiveModal,
		private listService: ListService,
		private sharedDataService: SharedDataService,
		private activitycostService: CrudService<ActivityCost>,
		private activityService: CrudService<Activity>
	) {

		this.search = {
			activity: new Search('activity')
		};



		this.selected = {
			activity: undefined
		};

		this.listService.getListItemsBySlug('activityexpense.type').subscribe((data: ListItem[]) => {
			this.types = data;
		});
	}

	ngOnInit() {
	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}



	load(id: number): void {
		if (id) {
			this.loading = true;
			this.activitycostService.getEntity(ActivityCost, 'activityexpense', id).subscribe(kpi => {
				this.cost = kpi;
				this.loadActivity();
				this.title = 'cost-edit';
				this.initItem();
			}, ({ error }) => {
				this.messageService.sendError(error, this.translateService.instant('labels.cost'));
				this.cost = undefined;
				this.loading = false;
			});

		} else {
			this.cost = new ActivityCost();
			this.cost.companyid = this.companyid;
			this.cost.projectid = this.projectid;
			this.title = 'cost-create';
			this.loading = false;
		}
		this.search.activity.addSimpleFilter('projectid', this.projectid);
	}

	loadActivity(): void {
		this.activityService.getEntity(Activity, 'activity', this.cost.activityid).subscribe((data: Activity) => {
			this.selected.activity = data;
		});
	}

	initItem(): void {

		this.loading = false;
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	submit(): void {
		if (this.selected.activity) {
			this.cost.activityid = this.selected.activity.id;

			if (!this.cost.id) {
				this.activitycostService.createEntity(ActivityCost, 'activityexpense', this.cost).subscribe(response => {
					this.cost = response;
					this.messageService.sendSuccess(
						this.translateService.instant('labels.cost-save-success'),
						this.translateService.instant('labels.success')
					);
					this.activeModal.close(this.cost);
				}, ({ error }) => {
					this.messageService.sendError(
						error.msg ? error.msg : error,
						this.translateService.instant('labels.event-save-error')
					);
				});
			} else {
				this.activitycostService.saveEntity(ActivityCost, 'activityexpense', this.cost).subscribe(response => {
					this.cost = response;
					this.messageService.sendSuccess(
						this.translateService.instant('labels.cost-save-success'),
						this.translateService.instant('labels.success')
					);
					this.activeModal.close(this.cost);
				}, ({ error }) => {
					this.messageService.sendError(
						error.msg ? error.msg : error,
						this.translateService.instant('labels.event-save-error')
					);
				});
			}
		}
	}

}
